var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "#D71924"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2288_560)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3463 43.1707H46.1231H13.877H12.6538C12.2953 43.1707 12.0211 42.8755 12.0211 42.538C12.0211 42.1795 12.2953 41.9053 12.6538 41.9053H13.2443V39.8807C13.2443 39.5433 13.5185 39.248 13.877 39.248H46.1231C46.4816 39.248 46.7557 39.5433 46.7557 39.8807V41.9053H47.3463C47.7048 41.9053 47.9789 42.1795 47.9789 42.538C47.9789 42.8755 47.7048 43.1707 47.3463 43.1707Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.276 45.5759H16.7241C16.3656 45.5759 16.0914 45.2807 16.0914 44.9432C16.0914 44.5847 16.3656 44.3105 16.7241 44.3105H43.276C43.6134 44.3105 43.9087 44.5847 43.9087 44.9432C43.9087 45.2807 43.6134 45.5759 43.276 45.5759Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1547 47.9587H19.8453C19.4868 47.9587 19.2126 47.6846 19.2126 47.326C19.2126 46.9886 19.4868 46.6934 19.8453 46.6934H40.1547C40.4921 46.6934 40.7873 46.9886 40.7873 47.326C40.7873 47.6846 40.4921 47.9587 40.1547 47.9587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1231 31.9504H13.8771C13.5185 31.9504 13.2444 31.6762 13.2444 31.3177V28.6815C13.2444 28.323 13.5185 28.0488 13.8771 28.0488H46.1231C46.4816 28.0488 46.7558 28.323 46.7558 28.6815V31.3177C46.7558 31.6762 46.4816 31.9504 46.1231 31.9504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9351 12.0215H46.1231C46.4816 12.0215 46.7558 12.3167 46.7558 12.6542V19.677C46.7558 20.0355 46.4816 20.3097 46.1231 20.3097H40.9351V12.0215Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7048 12.0215H40.2391V20.3097H35.7048V12.0215Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0703 14.3413C29.6099 12.9072 31.6766 12.0215 33.9543 12.0215H35.0088V20.3097H34.0598L28.0703 14.3413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3076 22.2286V20.668C25.3076 18.4114 26.1723 16.3657 27.5853 14.8262L33.5958 20.8367V22.2286H25.3076Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3076 25.455V22.9453H33.5958V25.455V27.4163H25.3076V25.455Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7628 27.4169V25.1814H23.051V27.4169H14.7628ZM14.7628 24.4644V21.2587H23.051V24.4644H14.7628ZM14.7628 20.5417V16.8721H23.051V20.5417H14.7628ZM14.7628 16.1551V12.6542C14.7628 12.3167 15.037 12.0215 15.3955 12.0215H22.4184C22.7558 12.0215 23.051 12.3167 23.051 12.6542V16.1551H14.7628Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4622 38.3845C17.1248 38.3845 16.8506 38.0892 16.8506 37.7518V33.576C16.8506 33.2175 17.1248 32.9434 17.4622 32.9434C17.8207 32.9434 18.0949 33.2175 18.0949 33.576V37.7518C18.0949 38.0892 17.8207 38.3845 17.4622 38.3845Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3304 37.5618C19.9719 37.5618 19.6978 37.2665 19.6978 36.9291V34.3983C19.6978 34.0398 19.9719 33.7656 20.3304 33.7656C20.6679 33.7656 20.9631 34.0398 20.9631 34.3983V36.9291C20.9631 37.2665 20.6679 37.5618 20.3304 37.5618Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8752 38.3845C30.5167 38.3845 30.2426 38.0892 30.2426 37.7518V33.576C30.2426 33.2175 30.5167 32.9434 30.8752 32.9434C31.2338 32.9434 31.5079 33.2175 31.5079 33.576V37.7518C31.5079 38.0892 31.2338 38.3845 30.8752 38.3845Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0282 37.5618C27.6697 37.5618 27.3955 37.2665 27.3955 36.9291V34.3983C27.3955 34.0398 27.6697 33.7656 28.0282 33.7656C28.3656 33.7656 28.6609 34.0398 28.6609 34.3983V36.9291C28.6609 37.2665 28.3656 37.5618 28.0282 37.5618Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2288_560"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon02);
export default __webpack_public_path__ + "static/media/icon_02.3114637b43c7bd4fba322e76731d8bb4.svg";
export { ForwardRef as ReactComponent };